import { useState, useEffect, useRef } from "react";
import { Link } from "@/components/common/Link";
export default function ExploreResources() {
  const ref = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const obs = new IntersectionObserver(([e]) => {
      if (e.isIntersecting) setVisible(true);
    }, {
      threshold: 0.1
    });
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, []);
  return <section style={{
    backgroundColor: "#F5F4F2",
    fontFamily: "Switzer, sans-serif"
  }} className="py-6 px-4 md:px-10 w-full overflow-hidden">
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Oswald:wght@400;500;600;700&family=Inter:wght@300;400;500;600&display=swap');
        
        .resources-learn-btn {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          cursor: pointer;
          transition: opacity 0.15s ease, background-color 0.15s ease;
          text-decoration: none;
        }
        .resources-learn-btn:hover {
          opacity: 0.85;
        }
      `}</style>

      <div ref={ref} className={`transition-all duration-700 ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"} max-w-[1400px] mx-auto shadow-lg`} style={{
      borderRadius: "28px",
      marginBottom: "48px",
      backgroundImage: "linear-gradient(90deg, rgba(1,139,185,1) 0%, rgba(52,73,154,1) 100%)",
      overflow: "hidden"
    }}>
        <div className="flex flex-col lg:flex-row items-center w-full p-6 sm:p-10 md:p-16 gap-8 md:gap-16">
          
          {/* Imagen */}
          <div className="w-full lg:w-[45%] flex justify-center">
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1768199/img/STL_Speaker.jpg" alt="Speaker on stage" loading="lazy" className="w-full object-cover !h-[600px]" style={{
            borderRadius: "20px",
            display: "block",
            maxHeight: "500px"
          }} />
          </div>

          {/* Contenido de Texto */}
          <div className="flex flex-col w-full lg:w-[55%] gap-4 md:gap-6">
            <h1 style={{
            color: "rgb(255, 255, 255)",
            fontFamily: "Switzer, sans-serif",
            fontSize: "clamp(28px, 4vw, 48px)",
            fontWeight: "400",
            lineHeight: "1.15",
            textTransform: "uppercase",
            margin: 0,
            padding: 0
          }}>
              EXPLORA{" "}
              <span style={{
              display: "inline-block",
              backgroundColor: "rgb(255, 255, 255)",
              color: "rgb(53, 53, 51)",
              borderRadius: "50px",
              paddingLeft: "16px",
              paddingRight: "16px",
              paddingTop: "2px",
              paddingBottom: "2px",
              lineHeight: "normal",
              fontWeight: "400",
              marginTop: "4px"
            }}>
                RECURSOS
              </span>{" "}
              DISEÑADOS PARA EL CRECIMIENTO ESPIRITUAL Y APOYO MINISTERIAL
            </h1>

            <p style={{
            color: "rgb(255, 255, 255)",
            fontFamily: "Switzer, sans-serif",
            fontSize: "clamp(16px, 1.8vw, 20px)",
            fontWeight: "300",
            lineHeight: "1.5",
            margin: 0,
            padding: 0
          }}>
              Ya sea que busque oportunidades ministeriales, el logotipo de AD, estatutos de la iglesia u otras ayudas, encuentre recursos para su ministerio, iglesia aquí
            </p>

            <div className="pt-2">
              <Link to="#" className="resources-learn-btn" style={{
              color: "rgb(255, 255, 255)",
              fontFamily: "Inter, sans-serif",
              fontSize: "14px",
              fontWeight: "500",
              lineHeight: "21px",
              backgroundColor: "rgb(53, 53, 51)",
              borderRadius: "28px",
              border: "1px solid rgb(53, 53, 51)",
              padding: "4px 4px 4px 16px",
              textTransform: "uppercase",
              textAlign: "center",
              textDecoration: "none"
            }}>
                MÁS INFORMACIÓN
                <span style={{
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                width: "28px",
                height: "28px",
                borderRadius: "50%",
                backgroundColor: "rgb(53, 53, 51)",
                border: "2px solid rgba(255,255,255,0.4)",
                flexShrink: 0
              }}>
                  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M2.5 11.5L11.5 2.5M11.5 2.5H5M11.5 2.5V9" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </span>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>;
}